import { ColumnBoxFlexFullWidth } from '../common/boxes';
import { Typography } from '@mui/material';

const Dashboard = () => {
  return (
    <ColumnBoxFlexFullWidth alignItems={'center'}>
      <Typography variant={'h3'}>Admin Dashboard</Typography>
    </ColumnBoxFlexFullWidth>
  )
};
export default Dashboard;